import Vue from 'vue'
import { Plugin } from "@nuxt/types"
import { SitecoreJssPlaceholderPlugin } from '@sitecore-jss/sitecore-jss-vue'

let componentFactory: (name: string) => Vue.Component | null
try {
  componentFactory = require('../../../sitecore/component-factory').default
} catch (err) {
  console.warn('Failed to import component factory, continuing without.', err)
  componentFactory = () => null
}

Vue.use(SitecoreJssPlaceholderPlugin, { componentFactory })

const jss: Plugin = (_, inject) => {
  inject('jss', { componentFactory })
}

export default jss
